(() => {
  "use strict";

  /* ==================================================
     ELEMENTS
  ================================================== */

  const hero = document.getElementById("hero");
  const heroMedia = document.getElementById("heroMedia");
  const siteHeader = document.getElementById("siteHeader");
  const backToTop = document.getElementById("backToTop");
  const menuButton = document.getElementById("menuButton");
  const headerNav = document.getElementById("headerNav");

  if (
    !hero ||
    !heroMedia ||
    !siteHeader ||
    !backToTop ||
    !menuButton ||
    !headerNav
  ) {
    return;
  }

  const headerLinks = headerNav.querySelectorAll("a");
  const heroSlides = Array.from(heroMedia.querySelectorAll(".hero-slide"));

  const mobileMedia = window.matchMedia("(max-width: 700px)");
  const reducedMotionMedia = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  );

  /* ==================================================
     HERO CAROUSEL
  ================================================== */

  const HERO_INTERVAL = 3800;

  let currentSlideIndex = 0;
  let carouselTimer = null;

  const stopHeroCarousel = () => {
    if (carouselTimer !== null) {
      window.clearInterval(carouselTimer);
      carouselTimer = null;
    }
  };

  const showHeroSlide = (nextIndex) => {
    if (heroSlides.length < 2) {
      return;
    }

    heroSlides[currentSlideIndex].classList.remove("is-active");

    currentSlideIndex =
      (nextIndex + heroSlides.length) %
      heroSlides.length;

    heroSlides[currentSlideIndex].classList.add("is-active");
  };

  const showNextHeroSlide = () => {
    showHeroSlide(currentSlideIndex + 1);
  };

  const startHeroCarousel = () => {
    stopHeroCarousel();

    if (
      reducedMotionMedia.matches ||
      document.hidden ||
      heroSlides.length < 2
    ) {
      return;
    }

    carouselTimer = window.setInterval(
      showNextHeroSlide,
      HERO_INTERVAL
    );
  };

  /*
    3枚ともHTMLに存在するため、
    JSで画像生成する必要はありません。

    2枚目・3枚目のPC画像：
    fv-bg-pc-02.webp
    fv-bg-pc-03.webp

    SP画像：
    fv-bg-sp-02.webp
    fv-bg-sp-03.webp
  */
  startHeroCarousel();

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      stopHeroCarousel();
    } else {
      startHeroCarousel();
    }
  });

  const handleReducedMotionChange = () => {
    if (reducedMotionMedia.matches) {
      stopHeroCarousel();
      showHeroSlide(0);
    } else {
      startHeroCarousel();
    }
  };

  if (typeof reducedMotionMedia.addEventListener === "function") {
    reducedMotionMedia.addEventListener(
      "change",
      handleReducedMotionChange
    );
  } else if (typeof reducedMotionMedia.addListener === "function") {
    reducedMotionMedia.addListener(
      handleReducedMotionChange
    );
  }

  /* ==================================================
     MOBILE MENU
  ================================================== */

  const closeMenu = () => {
    menuButton.classList.remove("is-open");
    headerNav.classList.remove("is-open");

    menuButton.setAttribute("aria-expanded", "false");
    menuButton.setAttribute("aria-label", "メニューを開く");

    document.body.classList.remove("menu-open");
  };

  const openMenu = () => {
    menuButton.classList.add("is-open");
    headerNav.classList.add("is-open");

    menuButton.setAttribute("aria-expanded", "true");
    menuButton.setAttribute("aria-label", "メニューを閉じる");

    document.body.classList.add("menu-open");
  };

  menuButton.addEventListener("click", () => {
    const isOpen =
      menuButton.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  headerLinks.forEach((link) => {
    link.addEventListener("click", closeMenu);
  });

  /* ==================================================
     HEADER VISIBILITY
  ================================================== */

  if ("IntersectionObserver" in window) {
    const heroObserver = new IntersectionObserver(
      ([entry]) => {
        const heroPassed =
          !entry.isIntersecting &&
          entry.boundingClientRect.bottom <= 0;

        siteHeader.classList.toggle(
          "is-visible",
          heroPassed
        );

        if (!heroPassed) {
          closeMenu();
        }
      },
      {
        threshold: 0
      }
    );

    heroObserver.observe(hero);
  } else {
    const updateHeaderFallback = () => {
      const heroPassed =
        window.scrollY >= hero.offsetHeight;

      siteHeader.classList.toggle(
        "is-visible",
        heroPassed
      );

      if (!heroPassed) {
        closeMenu();
      }
    };

    window.addEventListener(
      "scroll",
      updateHeaderFallback,
      {
        passive: true
      }
    );

    updateHeaderFallback();
  }

  /* ==================================================
     BACK TO TOP
  ================================================== */

  let scrollTicking = false;

  const updateBackToTop = () => {
    backToTop.classList.toggle(
      "is-visible",
      window.scrollY > 500
    );

    scrollTicking = false;
  };

  window.addEventListener(
    "scroll",
    () => {
      if (!scrollTicking) {
        window.requestAnimationFrame(
          updateBackToTop
        );

        scrollTicking = true;
      }
    },
    {
      passive: true
    }
  );

  updateBackToTop();

  /* ==================================================
     VIEWPORT CHANGE
  ================================================== */

  const handleViewportChange = (event) => {
    if (!event.matches) {
      closeMenu();
    }
  };

  if (typeof mobileMedia.addEventListener === "function") {
    mobileMedia.addEventListener(
      "change",
      handleViewportChange
    );
  } else if (typeof mobileMedia.addListener === "function") {
    mobileMedia.addListener(
      handleViewportChange
    );
  }

  /* ==================================================
     ESCAPE
  ================================================== */

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeMenu();
    }
  });
})();
